import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/clients/$clientId")({
  component: () => <Outlet />,
});
